import React, { useState } from 'react';
import Media from 'react-responsive'

import Navbar from '../components/general/navbar/Navbar'
import Footer from '../components/general/Footer'
import MobileNavbar from '../components/mobile/MobileNavbar'
import MobileFooter from '../components/mobile/MobileFooter'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch('/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Email sent:', data);
      })
      .catch((error) => {
        console.error('Error sending email:', error);
      });
  };

  return (
    <div className='relative top-0'>
        <Media query="(max-width: 768px)">
        {isMobile => (
          isMobile ? <MobileNavbar /> : <Navbar absolute={false} color='navy' />
        )}
      </Media>
    
    <div className='flex flex-col justify-center items-center font-display font-bold text-navy h-3/4 animate-fadein'>
      <br />
      <br />
      <br />
      <br />
      <br />
            <img src={'/various/50yrs.webp'} 
                className='w-1/5 object-contain'/>
            <div className='text-center'>
                <br />
                <div className='font-regular text-2xl'>
                  <br />
              If you would like to contact us, please email <a href="mailto:hr@masseysglass.com">
          <span className='font-bold underline'> hr@masseysglass.com </span>
          </a>
            </div>
            </div>
            
        </div>
        <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    <Media query="(max-width: 768px)">
        {isMobile => (
          isMobile ? <MobileFooter /> : <Footer />
        )}
      </Media>
    </div>
  );
};

export default Contact;
